import "./App.css";
import { BrowserRouter } from "react-router";
import AppRouter from "./routes/index";
import { Provider } from "react-redux";
import store from "@store/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/common-style.scss";
import Loader from "@components/loader/Loader";

function App() {
  // const isCloudFrontUrl = window.location.href.includes("cloudfront.net");

  // if (isCloudFrontUrl) {
  //   return (
  //     <div>
  //       <h1>Page Not Found</h1>
  //       <p>This page is not accessible directly via CloudFront.</p>
  //     </div>
  //   );
  // }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppRouter />
        <Loader />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
